import { Box, Stack, useMantineTheme } from '@mantine/core';
import { Button } from '@repo/foundations';
import { CompanyNamesCarousel } from '../../components/CompanyNamesCarousel';
import PlansGrid from './PlansGrid';
import PlansPageHeader from './PlansPageHeader';

function PlansPage() {
	const handleNavigateToPricingPage = () => {
		window.open('https://secoda.co/pricing', '_blank');
	};

	const theme = useMantineTheme();

	return (
		<Stack spacing="xl" align="center" px="2xl" pb="2xl">
			<PlansPageHeader />
			<PlansGrid />
			<Box maw={'1275px'} w={'100%'}>
				<CompanyNamesCarousel
					withG2
					backgroundColor={theme.other.getColor('surface/app/default')}
				/>
			</Box>
			<Button
				rightIconName="arrowUpRight"
				onClick={handleNavigateToPricingPage}
			>
				See all features
			</Button>
		</Stack>
	);
}

export default PlansPage;
